<footer id="footer" [style]="customStyle()">
  <div class="footer-section">
    <div class="footer-navigation">
      <span>
        <a [href]="isUserAuthed ? loggedKnowledgeUrl : guestKnowledgeUrl" target="_blank" rel="noopener">Help</a>
        <a href="https://scoot.app/company/about-us/" target="_blank" rel="noopener">Company</a>
        <a href="https://scoot.app/terms-of-use" target="_blank" rel="noopener">Terms</a>
        <a href="https://scoot.app/privacy-policy/" target="_blank" rel="noopener">Privacy</a>
        <a href="https://scoot.app/company/contact-us/" target="_blank" rel="noopener">Contact</a>
      </span>
    </div>
    <div style="text-align: center">
      <div class="copyright-text">
        Copyright &copy;{{ currentYear }} Scoot. Scoot is protected by
        <a
          href="https://image-ppubs.uspto.gov/dirsearch-public/print/downloadPdf/20210377062"
          target="_blank"
          rel="noopener"
          >U.S. patent 11,575,531</a
        >
        and additional pending patents. Scoot Inc. all rights reserved.
      </div>
    </div>
  </div>
</footer>
